import {RootState} from '../../store';

const key = 'contacts';

export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};

export const visibilitySelector = (state: RootState) => {
    return state[key].visibility;
};


